import { useCallback, useEffect, useState } from 'react';
import { NormalizedEntity } from 'Interfaces/Common';
import { UserAvatar } from 'Interfaces/User';
import Toast from 'Services/Toast';
import { isNotEmpty } from 'Utils/functions';

import useSignersAvatarsGet from './useSignersAvatarsGet';

export default documentId => {
  const [userAvatars, setUserAvatars] = useState<NormalizedEntity<UserAvatar> | {}>({});
  const [getSignersAvatars, isLoading] = useSignersAvatarsGet();

  const handleSignersAvatarsGet = useCallback(async () => {
    try {
      const avatars = await getSignersAvatars({ documentId });

      if (isNotEmpty(avatars)) {
        setUserAvatars(avatars);
      }
    } catch (error) {
      Toast.handleErrors(error);
    }
  }, [documentId, getSignersAvatars]);

  useEffect(() => {
    documentId && handleSignersAvatarsGet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentId]);

  return [userAvatars, isLoading] as const;
};
